import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueGtm from 'vue-gtm';
import settings from './settings/settings';

Vue.config.productionTip = false;
const primeGtmid = process.env.NODE_ENV === 'development' ? 'GTM-5ZSPN5K' : 'GTM-TN9NGXT';
const gtmid = settings.parameters.gtmid;
const gtmDebug = process.env.NODE_ENV === 'development' ? true : false;
/**
 * @type {Array|string}
 */
let gtmIds = primeGtmid;
if (gtmid && primeGtmid !== gtmid) gtmIds = [primeGtmid, gtmid];

Vue.use(VueGtm, {
  id: gtmIds,
  debug: gtmDebug,
  vueRouter: router
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
